import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AvatarModule } from 'ngx-avatars';

@Component({
  selector: 'adf-user-menu',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, AvatarModule, TranslatePipe],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  private readonly _router = inject(Router);
  logout = output<void>();
  userDisplayName = input.required<string | undefined>();

  onLogout() {
    this.logout.emit();
  }

  onProfile() {
    this._router.navigateByUrl('/user-profile');
  }
}
